import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "aboutTop" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "About IKEP", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://twitter.com/CreativeIKEP",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: "/images/Twitter_Logo_Blue.png" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://github.com/creativeIKEP",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: "/images/GitHub-Mark-Light-120px-plus.png" })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "skill" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Skill"),
  /*#__PURE__*/_createElementVNode("div", { class: "skillCard" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Programming Language"),
    /*#__PURE__*/_createElementVNode("div", null, " C, C++, C#, Java, Swift, Objective-C, HTML/CSS, JavaScript, Python, Go, SQL, Cg/HLSL ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "skillCard" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Software"),
    /*#__PURE__*/_createElementVNode("div", null, " Unity, Unreal Engine, Processing, openFrameworks, Blender, TouchDesigner, Adobe, Xamarin ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "skillCard" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Platform & Others"),
    /*#__PURE__*/_createElementVNode("div", null, " Google Apps Script, Google Cloud Platform, Firebase, OpenCV, Dialogflow, DirectX, ARToolKit, ARKit, Django, Arduino, WebGL, Keras, Tensorflow, Chainer, PyTorch, Salesforce, Vue.js ")
  ])
], -1)
const _hoisted_6 = { class: "skill" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "Work Experience", -1)
const _hoisted_8 = { class: "skillCard" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 2022/04 ~ ")
const _hoisted_10 = {
  href: "https://reality.inc/",
  target: "_blank"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 2019/09 ")
const _hoisted_12 = {
  href: "https://www.team-lab.com/",
  target: "_blank"
}
const _hoisted_13 = { href: "https://ikep.hatenablog.com/entry/2019/11/11/144217" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 2019/08 ")
const _hoisted_15 = {
  href: "https://naked.co.jp/",
  target: "_blank"
}
const _hoisted_16 = { href: "https://ikep.hatenablog.com/entry/2019/09/01/200144" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 2019/03 ")
const _hoisted_18 = {
  href: "https://aiming-inc.com/ja/",
  target: "_blank"
}
const _hoisted_19 = { href: "https://ikep.hatenablog.com/entry/2019/04/01/152120" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 2019/02 ")
const _hoisted_21 = {
  href: "https://www.nintendo.co.jp/index.html",
  target: "_blank"
}
const _hoisted_22 = {
  href: "https://www.nintendo.co.jp/jobs/internship/index.html",
  target: "_blank"
}
const _hoisted_23 = { class: "skill" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h2", null, "Prize & Exhibition", -1)
const _hoisted_25 = { class: "skillCard" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 2021/09 ")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://ivrc.net/2021/",
  target: "_blank"
}, "Interverse Virtual Reality Challenge 2021 (IVRC2021)", -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 2020/09 ")
const _hoisted_29 = {
  href: "https://talent.supporterz.jp/geekten/2020/",
  target: "_blank"
}
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 2019/10 ")
const _hoisted_31 = {
  href: "https://u22procon.com/2019/",
  target: "_blank"
}
const _hoisted_32 = {
  href: "https://u22procon.com/2019/report/",
  target: "_blank"
}
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" 2018/11 ")
const _hoisted_34 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://kc-i.jp/activity/award/isca/2018/",
  target: "_blank"
}, "ISCA2018(INTERNATIONAL STUDENTS CREATIVE AWARD2018)", -1)
const _hoisted_35 = {
  href: "https://kc-i.jp/activity/award/isca/2018/winners/",
  target: "_blank"
}
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 2018/02 ")
const _hoisted_37 = {
  href: "https://mshackathon0203.peatix.com/",
  target: "_blank"
}
const _hoisted_38 = { href: "https://ikep.hatenablog.com/entry/2018/05/25/203747" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" 2017/10 ")
const _hoisted_40 = {
  href: "http://ivrc.net/2017/",
  target: "_blank"
}
const _hoisted_41 = {
  href: "http://ivrc.net/archive/year/2017/",
  target: "_blank"
}
const _hoisted_42 = { class: "skill" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("h2", null, "Qualification", -1)
const _hoisted_44 = { class: "skillCard" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" 2022/11 ")
const _hoisted_46 = {
  href: "https://cloud.google.com/certification/cloud-developer",
  target: "_blank"
}
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" 2019/08 ")
const _hoisted_48 = {
  href: "https://www.cgarts.or.jp/v1/kentei/about/cg_engineer/index.html",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_News = _resolveComponent("News")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", null, _toDisplayString(_ctx.$t("message.AboutMe1")), 1),
      _createElementVNode("div", null, _toDisplayString(_ctx.$t("message.AboutMe2")), 1)
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _hoisted_9,
            _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.$t("message.reality-inc")), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("message.Engineer")) + ". " + _toDisplayString(_ctx.$t("message.full-time-employee")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_11,
            _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.$t("message.teamLab")), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("message.InteractiveTeamEngineer")) + " ", 1),
            _createElementVNode("a", _hoisted_13, _toDisplayString(_ctx.$t("message.Internship")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_14,
            _createElementVNode("a", _hoisted_15, _toDisplayString(_ctx.$t("message.NAKED_INC")), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("message.TechnicalDirector_MediaArtProgrammer")) + " ", 1),
            _createElementVNode("a", _hoisted_16, _toDisplayString(_ctx.$t("message.Internship")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_17,
            _createElementVNode("a", _hoisted_18, _toDisplayString(_ctx.$t("message.Aiming")), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("message.Engineer")) + " ", 1),
            _createElementVNode("a", _hoisted_19, _toDisplayString(_ctx.$t("message.Internship")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_20,
            _createElementVNode("a", _hoisted_21, _toDisplayString(_ctx.$t("message.Nintendo")), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("message.GameDevelopmentEngineer")) + " ", 1),
            _createElementVNode("a", _hoisted_22, _toDisplayString(_ctx.$t("message.Internship")), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _hoisted_24,
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _hoisted_26,
            _hoisted_27,
            _createTextVNode(_toDisplayString(_ctx.$t("message.IVRC2021Prize")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_28,
            _createElementVNode("a", _hoisted_29, _toDisplayString(_ctx.$t("message.GEEK_TEN")), 1),
            _createTextVNode(_toDisplayString(_ctx.$t("message.GEEK_TEN_Presentation")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_30,
            _createElementVNode("a", _hoisted_31, _toDisplayString(_ctx.$t("message.U22ProgramingContest")), 1),
            _createTextVNode(_toDisplayString(_ctx.$t("message.InThe")), 1),
            _createElementVNode("a", _hoisted_32, _toDisplayString(_ctx.$t("message.TreadrawBest40")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_33,
            _hoisted_34,
            _createTextVNode(_toDisplayString(_ctx.$t("message.InThe")), 1),
            _createElementVNode("a", _hoisted_35, _toDisplayString(_ctx.$t("message.I_AM_MAN2ndPrize")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_36,
            _createElementVNode("a", _hoisted_37, _toDisplayString(_ctx.$t("message.MicrosoftHoloLenshackathon")), 1),
            _createTextVNode(_toDisplayString(_ctx.$t("message.InThe")), 1),
            _createElementVNode("a", _hoisted_38, _toDisplayString(_ctx.$t("message.HoloPresenterPrize")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_39,
            _createElementVNode("a", _hoisted_40, _toDisplayString(_ctx.$t("message.IVRC2017")), 1),
            _createTextVNode(_toDisplayString(_ctx.$t("message.InThe")), 1),
            _createElementVNode("a", _hoisted_41, _toDisplayString(_ctx.$t("message.ShineKaguyaExhibit")), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_42, [
      _hoisted_43,
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _hoisted_45,
            _createElementVNode("a", _hoisted_46, _toDisplayString(_ctx.$t("message.gcp-pcd")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_47,
            _createElementVNode("a", _hoisted_48, _toDisplayString(_ctx.$t("message.CG-ARTS-test")), 1),
            _createTextVNode(_toDisplayString(_ctx.$t("message.expert")), 1)
          ])
        ])
      ])
    ]),
    _createVNode(_component_News, {
      title: "Past NEWS",
      displayNewsCount: 999
    })
  ], 64))
}